/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector, createSlice } from '@reduxjs/toolkit';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import { getUserThunk } from './userAccounts.thunk';

/* Initial State */
const initialState = {
  status: ThunkStatus.IDLE,
  resource: undefined,
  error: undefined,
};

/* Slice */
export const userAccountsSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getUserThunk.pending, (state) => {
        state.status = ThunkStatus.LOADING;
      })
      .addCase(getUserThunk.fulfilled, (state, action) => {
        state.status = ThunkStatus.SUCCEEDED;
        state.resource = action.payload;
        state.error = undefined;
      })
      .addCase(getUserThunk.rejected, (state, action) => {
        state.status = ThunkStatus.FAILED;
        state.error = action?.error?.message;
      });
  },
});

/* Selectors */
const selectUserAccount = state => state[userAccountsSlice.name];
export const selectUserStatus = createSelector(selectUserAccount, ({ status }) => status);
export const selectUserData = createSelector(selectUserAccount, ({ resource }) => resource);
